__turbopack_context__.v({
  "className": "cormorant_8e959ad6-module__nPkX9q__className",
});
